import React from "react";
import "./style.css";

const Backdrop = (props) => {
  return (
    <div className="backdrop-container" onClick={props.backdropClick}></div>
  );
};
export default Backdrop;
